import React from 'react';
import InstituteCrudPage from './InstituteCrudPage';
import { entityConfigs } from '../../config/entityConfigs';

export default function StudyMaterialsPage() {
  return <InstituteCrudPage config={entityConfigs['study-materials']} />;
}
